import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { IWizItemRenderer, WizLabel, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { FunctionObj } from '@wizeoo/akm-compute-lib';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';

/** Renderer vignette d'une entité métier */
@Component({
  selector: 'add-function-renderer',
  templateUrl: './add-function.renderer.html',
})
export class AddFunctionRenderer implements IWizItemRenderer<null, FunctionObj> {
  constructor(public elementRef: ElementRef) {}

  @ViewChild('lbTitle') lbTitle: WizLabel;
  @ViewChild('lbContent') lbContent: WizLabel;

  public currentFormula: string = '';
  public codeAndLabel: string = '';

  private _data: FunctionObj;
  public get data(): FunctionObj {
    return this._data;
  }
  @Input()
  public set data(data: FunctionObj) {
    this._data = data;
    this.codeAndLabel = this.data.getCodeAndLabel();
    this.currentFormula = this.data.getDescription();
  }

  /** sélection / ou pas de la measure, depuis le graph */
  public selectMe(event: Event): void {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_QUICK_SELECT, this.data));
  }
}
